import Vue from "vue";
import Router from "vue-router";
import NotFound from "@/pages/shared/404";
import Layout from "@/components/layout";
import Index from "@/pages/home/index";
import Data from "@/pages/data/index";
import Orders from "@/pages/orders/index";
import OrdersDetail from "@/pages/orders/detail";
import OrdersOutcome from "@/pages/orders/outcome";
import OrdersMerge from "@/pages/orders/merge";
import Contact from "@/pages/contact/index";
import Nim from "@/pages/contact/nim";
import Store from "@/pages/store/index";
import StoreOrigin from "@/pages/store/origin";
import StoreShipment from "@/pages/store/shipment";
import AddNewItem from "@/pages/commodity/newitem";
import Draft from "@/pages/commodity/draft";
import Active from "@/pages/commodity/active";
import VctiveHstory from "@/pages/commodity/vctivehstory";
import BuyNow from "@/pages/commodity/buynow";
import Scheduled from "@/pages/commodity/scheduled";
import Unsold from "@/pages/commodity/unsold";
import Offer from "@/pages/commodity/offer";
import Messages from "@/pages/messages/index";
import Login from "@/pages/shared/login";
import Register from "@/pages/shared/register";
import ForgotPassword from "@/pages/shared/forgot";
import Wallet from "@/pages/wallet/index";
import Blacklist from "@/pages/blacklist/index";

import Upload from "@/pages/upload/index";

Vue.use(Router);

import { i18n, translate as $t } from "../common/lang/vue-i18n";

export default new Router({
  routes: [
    {
      path: "/",
      name: "layout",
      component: Layout,
      children: [
        {
          path: "/index",
          redirect: "/"
        },
        {
          path: "/",
          name: "index",
          component: Index,
          meta: {
            title: $t('menu.overview')
          }
        },
        {
          path: "/commodity/New",
          name: "commodity-New",
          component: AddNewItem,
          meta: {
            title: $t('menu.addNewltem')
          }
        },
        {
          path: "/commodity/Draft",
          name: "commodity-Draft",
          component: Draft,
          meta: {
            title: $t('menu.draft')
          }
        },
        {
          path: "/commodity/Active/Auction",
          name: "commodity-Auction",
          component: Active,
          meta: {
            title: $t('menu.auction')
          }
        },
        {
          path: "/commodity/Active/Buy",
          name: "commodity-Buy",
          component: BuyNow,
          meta: {
            title: $t('menu.buyItNow')
          }
        },
        {
          path: "/commodity/Active/VctiveHstory/:id?",
          name: "commodity-VctiveHstory",
          component: VctiveHstory
        },
        {
          path: "/commodity/Scheduled",
          name: "commodity-Scheduled",
          component: Scheduled,
          meta: {
            title: $t('menu.scheduled')
          }
        },
        {
          path: "/commodity/Unsold",
          name: "commodity-Unsold",
          component: Unsold,
          meta: {
            title: $t('menu.unsold')
          }
        },
        {
          path: "/commodity/Offer",
          name: "commodity-Offer",
          component: Offer,
          meta: {
            title: $t('menu.offer')
          }
        },
        {
          path: "/orders",
          name: "orders",
          component: Orders,
          meta: {
            title: $t('menu.myOrders')
          }
        },
        {
          path: "/orders/detail",
          name: "orders-detail",
          component: OrdersDetail,
          meta: {
            title: $t('menu.orderDetail')
          }
        },
        {
          path: "/orders/outcome/:id",
          name: "orders-outcome",
          component: OrdersOutcome,
          meta: {
            title: $t('menu.orderDetail')
          }
        },
        {
          path: "/orders/merge",
          name: "orders-merge",
          component: OrdersMerge,
          meta: {
            title: $t('menu.mergeOrders')
          }
        },
        {
          path: "/contact",
          name: "contact",
          component: Contact,
          meta: {
            title: $t('menu.contactCardhobby')
          }
        },
        {
          path: "/data",
          name: "data",
          component: Data,
          meta: {
            title: $t('menu.businessData')
          }
        },
        {
          path: "/store",
          name: "store",
          component: Store,
          meta: {
            title: $t('menu.myStore')
          }
        },
        {
          path: "/wallet",
          name: "wallet",
          component: Wallet,
          meta: {
            title: $t('menu.wallet')
          }
        },
        {
          path: "/blacklist",
          name: "blacklist",
          component: Blacklist,
          meta: {
            title: $t('menu.blacklist')
          }
        },
        {
          path: "/store/origin",
          name: "store-origin",
          component: StoreOrigin,
          meta: {
            title: $t('menu.myStore')
          }
        },
        {
          path: "/store/shipment",
          name: "store-shipment",
          component: StoreShipment,
          meta: {
            title: $t('menu.myStore')
          }
        },
        {
          path: "/messages",
          name: "messages",
          component: Messages,
          meta: {
            title: $t('menu.messages')
          }
        }
      ]
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        title: $t('menu.login')
      }
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
      meta: {
        title: $t('menu.register')
      }
    },
    {
      path: "/forgot",
      name: "Forgot",
      component: ForgotPassword,
      meta: {
        title: $t('menu.forgotPassword')
      }
    },
    {
      path: "/nim",
      name: "Nim",
      component: Nim,
      meta: {
        title: "NIM"
      }
    },
    {
      path: "/upload",
      name: "Upload",
      component: Upload,
      meta: {
        title: "Upload"
      }
    },
    {
      path: "*",
      component: NotFound,
      meta: {
        title: $t('menu.notFound')
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js